import { Typography, Tooltip } from '@mui/material';
import React from 'react';
import PurchaseOrders from 'types/entities/PurchaseOrders';

const SpecRefCell = React.memo((row: PurchaseOrders) => (
  <Tooltip arrow title={row.specref_ws ?? ''}>
    <Typography noWrap variant="body2">
      {row?.specref_ws}
    </Typography>
  </Tooltip>
));

export default SpecRefCell;
